export enum PaymentTermType {
  VALUE = 'VALUE',
  PERCENTAGE = 'PERCENTAGE',
  OTHER = 'OTHER'
}
